export var createWindow = function () { return (typeof window === 'undefined' ? null : window); };
//# sourceMappingURL=window.js.map
